import { Controller } from "@hotwired/stimulus"
import { Lightbox } from "lightbox3"

let viewer
let turboLifecycleInstalled = false

export function sharedLightbox() {
  if (typeof document === "undefined") return null

  viewer ||= Lightbox.init()
  installTurboLifecycle()
  return viewer
}

function installTurboLifecycle() {
  if (turboLifecycleInstalled || typeof document === "undefined") return

  document.addEventListener("turbo:before-cache", closeBeforeCache)
  turboLifecycleInstalled = true
}

function closeBeforeCache() {
  viewer?.close()
}

export default class extends Controller {
  connect() {
    console.log("X Tham")
    this.viewer = sharedLightbox()
    this.previousFocus = null
    this.hostDialog = null
    this.openHandler = (detail) => this.handleOpen(detail)
    this.closedHandler = () => this.handleClosed()
    this.viewer.on("open", this.openHandler).on("closed", this.closedHandler)
  }

  disconnect() {
    this.viewer?.off("open", this.openHandler).off("closed", this.closedHandler)
    this.viewer = null
    this.openHandler = null
    this.closedHandler = null
    this.previousFocus = null
    this.closeHostDialog()
  }

  handleOpen({ triggerEl }) {
    if (!this.element.contains(triggerEl)) return

    this.previousFocus = document.activeElement
    const dialog = triggerEl?.closest("dialog")
    if (!dialog) return

    // Lightbox3 creates its overlay in document.body. Put it in a separate
    // fullscreen native dialog so it enters the top layer above the host
    // dialog without inheriting the host modal's constrained dimensions.
    requestAnimationFrame(() => {
      const overlay = document.querySelector(".lightbox3-overlay")
      if (!overlay || !dialog.isConnected) return

      this.hostDialog = document.createElement("dialog")
      this.hostDialog.className = "image-gallery-lightbox-host"
      this.hostDialog.setAttribute("aria-label", "Image viewer")
      this.hostDialog.addEventListener("cancel", (event) => event.preventDefault())
      document.body.appendChild(this.hostDialog)
      this.hostDialog.showModal()
      this.hostDialog.appendChild(overlay)
    })
  }

  handleClosed() {
    if (this.previousFocus?.isConnected) this.previousFocus.focus()
    this.previousFocus = null
    this.closeHostDialog()
  }

  closeHostDialog() {
    if (!this.hostDialog) return

    if (this.hostDialog.open) this.hostDialog.close()
    this.hostDialog.remove()
    this.hostDialog = null
  }
}
